window.getParameterByName = function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

window.fieldWithValueExistsInCollection = function (collection, field, value) {
    var keyedTasks = _.keyBy(collection, field);

    return value in keyedTasks;
};

window.getItemByFieldAndValue = function (collection, field, value) {
    var keyedTasks = _.keyBy(collection, field);

    if(value in keyedTasks)
    {
        return keyedTasks[value];
    }

    return null;
};

/**
 * Transform an item to include a Vue Select compatable object for whatever keys you specify.
 *
 * @param item The object which to transform
 * @param configuration The array of configuration items to merge
 */
window.transformForDropdown = function(item, configuration){
    if( !_.isObject(item) )
    {
        return item;
    }

    _.forEach(configuration,function(mergeSet){
        if(_.isNull(item[mergeSet.id]) || item[mergeSet.id] === 0)
        {
            item[mergeSet.key] = null;
        }else{
            item[mergeSet.key] = {label:item[mergeSet.label], value: item[mergeSet.id]};
        }
    });

    return item;
}

/**
 * Transform an item which has been used for a Vue Select drop down back to its naturally
 * transformed state.
 *
 * @param item
 * @param configuration
 * @returns {*}
 */
window.transformFromDropdown = function(item, configuration){
    if( !_.isObject(item) )
    {
        return item;
    }

    _.forEach(configuration,function(mergeSet){
        if(_.isNull(item[mergeSet.key]) || !(mergeSet.key in item))
        {
            item[mergeSet.label] = 'Not Set';
            item[mergeSet.id] = null;
        }else{
            item[mergeSet.label] = item[mergeSet.key].label;
            item[mergeSet.id] = item[mergeSet.key].value;
        }
        delete item[mergeSet.key];
    });

    return item;
}

window.$(function($) { $.extend({
    form: function(url, data, method) {
        if (method == null) method = 'POST';
        if (data == null) data = {};

        var form = $('<form>').attr({
            method: method,
            action: url
        }).css({
            display: 'none'
        });

        var addData = function(name, data) {
            if ($.isArray(data)) {
                for (var i = 0; i < data.length; i++) {
                    var value = data[i];
                    addData(name + '[]', value);
                }
            } else if (typeof data === 'object') {
                for (var key in data) {
                    if (data.hasOwnProperty(key)) {
                        addData(name + '[' + key + ']', data[key]);
                    }
                }
            } else if (data != null) {
                form.append($('<input>').attr({
                    type: 'hidden',
                    name: String(name),
                    value: String(data)
                }));
            }
        };

        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                addData(key, data[key]);
            }
        }

        return form.appendTo('body');
    }
}); });